import { render } from "./ReleaseList.vue?vue&type=template&id=504470f3"
import script from "./ReleaseList.vue?vue&type=script&lang=js"
export * from "./ReleaseList.vue?vue&type=script&lang=js"

import "./ReleaseList.vue?vue&type=style&index=0&id=504470f3&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__